import { ConfigModel } from '../models/config.model';
import { apps } from './apps.factory';

export function getConfig(): ConfigModel {
  const origin = window.location.origin;
  if (/localhost:4200/.test(origin)) {
    return getDev();
  }
  if (/dev.developers.planzer.app/.test(origin)) {
    return getDev();
  }

  if (/at.developers.planzer.app/.test(origin)) {
    return getAt();
  }

  if (/uat.developers.planzer.app/.test(origin)) {
    return getUat();
  }

  if (/developers.app.planzer.ch/.test(origin)) {
    return getProd();
  }

  throw Error('Environment url is not supported');
}

function getDev(): ConfigModel {
  const serverUrl = 'https://dev.api.planzer.app';
  prefixServerUrl(serverUrl);

  return {
    authConfig: {
      clientId: '6fdf6a4c-799c-4212-aa87-0eece80fa7d1-b5e7b5c4-ecda-4420-3a7b-08dabe5c547b',
      issuer: 'https://dev.id.planzer.app',
      redirectUri: 'https://dev.developers.planzer.app',
      responseType: 'code',
      scope: '.default openid profile email offline_access',
      resource: serverUrl,
    },
    statusPageUrl: 'https://status.t7p.io',
    appInsights: {
      connectionString:
        'InstrumentationKey=6c2255a4-6b3e-4024-bf42-b6235394a5ce;IngestionEndpoint=https://westeurope-5.in.applicationinsights.azure.com/;LiveEndpoint=https://westeurope.livediagnostics.monitor.azure.com/',
    },
    apps: apps,
  };
}

function getAt(): ConfigModel {
  const serverUrl = 'https://at.api.planzer.app';
  prefixServerUrl(serverUrl);

  return {
    authConfig: {
      clientId: '27c908a8-0a3b-4950-b1e3-0cc8411bd992-888124a6-ddb4-4f52-f36e-08dabe749e7d',
      issuer: 'https://at.id.planzer.app',
      redirectUri: 'https://at.developers.planzer.app',
      responseType: 'code',
      scope: '.default openid profile email offline_access',
      resource: serverUrl,
    },
    statusPageUrl: 'https://status.t7p.io',
    appInsights: {
      connectionString:
        'InstrumentationKey=8b6efed2-a8f9-465a-9f1c-67b7f7e4f6cb;IngestionEndpoint=https://westeurope-5.in.applicationinsights.azure.com/;LiveEndpoint=https://westeurope.livediagnostics.monitor.azure.com/;ApplicationId=11b345ee-f082-444e-9f32-82c44a89a255',
    },
    apps: apps,
  };
}

function getUat(): ConfigModel {
  const serverUrl = 'https://uat.api.planzer.app';
  prefixServerUrl(serverUrl);

  return {
    authConfig: {
      clientId: '9f58cfa5-9c4a-45bc-8b6d-e9fefd1d835a-2401a96a-daa8-407e-a6a3-08dabd660bac',
      issuer: 'https://uat.id.planzer.app',
      redirectUri: 'https://uat.developers.planzer.app',
      responseType: 'code',
      scope: '.default openid profile email offline_access',
      resource: serverUrl,
    },
    statusPageUrl: 'https://status.t7p.io',
    appInsights: {
      connectionString:
        'InstrumentationKey=e0d70dc5-a517-4d1c-890f-194c1d205858;IngestionEndpoint=https://westeurope-5.in.applicationinsights.azure.com/;LiveEndpoint=https://westeurope.livediagnostics.monitor.azure.com/;ApplicationId=81bcf13b-9c48-43e1-afec-f2354cb3e45b',
    },
    apps: apps,
  };
}

function getProd(): ConfigModel {
  const serverUrl = 'https://api.app.planzer.ch';
  prefixServerUrl(serverUrl);

  return {
    authConfig: {
      clientId: '54c932d3-e7fc-457d-b586-289f6b1156ce-3c2594d6-85c5-46c1-2a1c-08dadda12436',
      issuer: 'https://id.planzer.ch',
      redirectUri: 'https://developers.app.planzer.ch',
      responseType: 'code',
      scope: '.default openid profile email offline_access',
      resource: serverUrl,
    },
    statusPageUrl: 'https://status.app.planzer.ch/',
    appInsights: {
      connectionString:
        'InstrumentationKey=350b838e-f665-41e6-801c-644f58ba4bd6;IngestionEndpoint=https://westeurope-5.in.applicationinsights.azure.com/;LiveEndpoint=https://westeurope.livediagnostics.monitor.azure.com/;ApplicationId=5d9f0df1-b989-4132-a1c7-f95457f1332e',
    },
    apps: apps,
  };
}

function prefixServerUrl(serverUrl: string): void {
  apps.forEach((app) => {
    app.openApiUrl = `${serverUrl}${app.openApiUrl}`;
    app.serverUrl = `${serverUrl}${app.serverUrl}`;
  });
}
